import layout from "~/layout/App/Index.vue";
import auth from "../middleware/auth";

const contractRoutes = {
  path: "/contracts",
  component: layout,
  name: "contracts",
  meta: {
    breadcrumb: [{ name: 'contracts', route: "contract.index" }],
    middleware: auth
  },
  children: [
    {
      path: "",
      component: () => import("~/views/Contract/Index"),
      name: "contract.index",
      meta: {
        breadcrumb: [{ name: "breadcrumb.overview" }],
        middleware: auth
      }
    },
    // {
    //   path: ":contractId/user",
    //   component: () => import("~/views/Contract/Customer"),
    //   name: "contract.user",
    //   meta: {
    //     middleware: auth
    //   }
    // },
    {
      path: ":contractName/settings",
      component: () => import("~/views/Contract/Setting"),
      name: "contracts.setting",
      meta: {
        breadcrumb: [
          { name: 'contracts', route: "contract.index" },
          { name: "contract.settings" }
        ],
        middleware: auth
      }
    }
  ]
};

export default contractRoutes;
